import React from 'react';
//Admin: Protected with AuthCheckAdmin
import Admin from '../AdminRoutes/Admin/AdminHome.component.jsx';

// Create routes
import CreateUser from '../AdminRoutes/CreateRoutes/CreateUser/UserCreate.component.jsx';
import CreateCompany from '../AdminRoutes/CreateRoutes/CreateCompany/CompanyCreate.component.jsx';
import CreateCourse from '../AdminRoutes/CreateRoutes/CreateCourse/CourseCreate.component.jsx';
import CreateNewsletter from '../AdminRoutes/CreateRoutes/CreateNewsletter/NewsletterCreate.component.jsx';

// Edit Routes
import EditCourse from '../AdminRoutes/EditRoutes/EditCourse/CourseEdit.component.jsx';
import EditCompany from '../AdminRoutes/EditRoutes/EditCompany/CompanyEdit.component.jsx';
import EditManagersAndUsers from '../AdminRoutes/EditRoutes/EditManagers/ManagersEdit.componentPage.jsx';
import EditNewsletter from '../AdminRoutes/EditRoutes/EditNewsletter/NewsEdit.component.jsx';

// Users
// import UserCourses from '../AdminRoutes/EditRoutes/EditUser/UserCoursesPage/UserCourses.component.jsx';
// import UserAdminHome from '../AdminRoutes/Admin/Users/UserHome/UserHomepage.component.jsx';
import UsersTab from '../AdminRoutes/Admin/Users/UserTabComponent.component.jsx';
// import UserCourseDetails from '../AdminRoutes/EditRoutes/EditUser/UserCoursesPage/UserCourseDetails.component.jsx';
import UserDetailsBasePage from '../UserDetails/UserDetails.component.jsx';

// Companies
import CompanyAdminHome from '../AdminRoutes/Admin/Companies/CompaniesHome/CompanyHomepage.component.jsx';
import CompaniesTab from '../AdminRoutes/Admin/Companies/CompaniesTabComponent.component.jsx';
// import EditManagerOrEmployee from '../AdminRoutes/EditRoutes/EditManagers/MEBasePage/EditManagerOrEmployee.jsx';
// import EditManagerOrEmployee from '../AdminRoutes/EditRoutes/EditManagers/MEBasePage/EditManagerOrEmployee.component.jsx';

// Courses
import CoursesTab from '../AdminRoutes/Admin/Courses/CoursesTabComponent.component.jsx';

// Newsletters
import NewslettersSubscribersList from '../AdminRoutes/Admin/NewsletterSubscribers.component.jsx';
import NewsletterTab from '../AdminRoutes/Admin/Newsletters/NewsletterTab.component.jsx';

// Discounts
import DiscountHomepage from '../AdminRoutes/CreateRoutes/CreateDiscount/DiscountHomepage.component.jsx';

// Payments
import PurchaseHistoryAdmin from '../AdminRoutes/Admin/Companies/Purchases/PurchaseHistory.component.jsx';
// import PurchaseHistoryOfUserAdmin from '../AdminRoutes/EditRoutes/EditUser/PurchaseHistoryPage/PurchaseHistory.component.jsx';

// Other
import GetInfo from '../AdminRoutes/GetInformation/GetInfo.component.jsx';
import CreateImage from '../AdminRoutes/CreateRoutes/CreateImage/CreateImage.component.jsx';

export const adminRoutes = [
  { path: '', element: <Admin /> },
  { path: 'create-course', element: <CreateCourse /> },
  { path: 'create-company', element: <CreateCompany /> },
  { path: 'create-user', element: <CreateUser /> },
  { path: 'create-image', element: <CreateImage /> },
  { path: 'information', element: <GetInfo /> },
  { path: 'discounts', element: <DiscountHomepage /> },
  { path: 'newsletter-subscribers', element: <NewslettersSubscribersList /> },
  // {
  //   path: 'certificate/:id/course/:courseId',
  //   element: <UserCourseDetails />,
  // },
  { path: 'create-newsletter', element: <CreateNewsletter /> },
  { path: 'edit-user/:id', element: <UserDetailsBasePage /> },
  // { path: 'edit-user/:id/course/:courseId', element: <UserCourseDetails /> },
  { path: 'company/purchase-history/:id', element: <PurchaseHistoryAdmin /> },
  { path: 'edit-newsletter/:id', element: <EditNewsletter /> },
  { path: 'edit-course/:id', element: <EditCourse /> },
  { path: 'company/employees/:id', element: <EditManagersAndUsers /> },
  // {
  //   path: 'company/:id/employee/:userId',
  //   element: <EditManagerOrEmployee />,
  // },
  { path: 'company/edit/:id', element: <EditCompany /> },
  { path: 'company-home/:id', element: <CompanyAdminHome /> },
  // { path: 'user-home/:id', element: <UserAdminHome /> },
  // { path: 'user/courses/:id', element: <UserCourses /> },
  // {
  //   path: 'user/purchase-history/:id',
  //   element: <PurchaseHistoryOfUserAdmin />,
  // },
  { path: 'courses', element: <CoursesTab /> },
  { path: 'companies', element: <CompaniesTab /> },
  { path: 'users', element: <UsersTab /> },
  { path: 'newsletters', element: <NewsletterTab /> },
];
